import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOMeta from '@/components/base/SEOMeta';
import Breadcrumb from '@/components/base/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';
import BrandIntro from './components/BrandIntro';
import Reputation from './components/Reputation';
import Contact from './components/Contact';

export default function AboutPage() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '海角社区是免费的吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，海角社区完全免费。任何人都可以自由浏览社区内容、参与讨论和分享自己的故事。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在海角社区发布文章？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '注册成为海角社区成员后，你可以在任意分类下发布自己的文章。我们鼓励原创内容，分享真实的生活体验和感悟。',
        },
      },
      {
        '@type': 'Question',
        name: '海角社区的内容审核标准是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们致力于维护一个健康、友善的社区环境。所有内容都需要遵守社区规范，禁止发布违法、侵权、恶意攻击等不当内容。',
        },
      },
      {
        '@type': 'Question',
        name: '如何联系海角社区团队？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '你可以通过页面底部的联系表单给我们留言，或发送邮件至 hello@haijiao.shequn.cn。我们会在工作时间内尽快回复。',
        },
      },
    ],
  };

  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于海角社区',
    description: '海角社区是一个开放、包容的在线交流社区，连接来自五湖四海的朋友，分享生活、情感、兴趣与故事。',
    url: 'https://baynetwork.github.io/about',
  };

  return (
    <>
      <ScrollToTop />
      <SEOMeta
        title="关于我们"
        description="了解海角社区的品牌故事、发展历程和核心价值。海角社区是一个开放、包容的在线交流社区，连接来自五湖四海的朋友，分享生活、情感、兴趣与故事。"
        keywords="海角社区,关于海角社区,社区品牌,在线社区介绍,联系我们"
        canonicalUrl="https://baynetwork.github.io/about"
      />
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(aboutSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>
          <BrandIntro />
          <Reputation />
          <Contact />
        </main>
        <Footer />
      </div>
    </>
  );
}